import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "df-preset-block" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["aria-label"];
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
import { useChrome } from "../../i18n/useChrome";
import { balancedColumns } from "../../composables/presets";
import PresetAmountButton from "./PresetAmountButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PresetAmountGrid',
    props: {
        maxColumns: {}
    },
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const props = __props;
        const { presets } = useDonation();
        const { tf } = useChrome();
        const maxCols = computed(() => props.maxColumns ?? 4);
        const gridStyle = computed(() => {
            const n = presets.value.length;
            const cap = Math.max(1, maxCols.value);
            return {
                "--df-preset-cols": String(balancedColumns(n, cap)),
                "--df-preset-cols-sm": String(balancedColumns(n, Math.min(3, cap))),
                "--df-preset-cols-xs": String(balancedColumns(n, Math.min(2, cap))),
            };
        });
        const selectedImageUrl = computed(() => presets.value.find((p) => p.selected)?.imageUrl ?? null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (selectedImageUrl.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "df-preset-block__img",
                        src: selectedImageUrl.value,
                        alt: ""
                    }, null, 8 /* PROPS */, _hoisted_2))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                    class: "df-presets",
                    role: "group",
                    "aria-label": _unref(tf)('amount.presetsLabel'),
                    style: _normalizeStyle(gridStyle.value)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (p) => {
                        return (_openBlock(), _createBlock(PresetAmountButton, {
                            key: p.id ?? p.amountMinor,
                            label: p.label,
                            description: p.description,
                            selected: p.selected,
                            onClick: ($event) => (p.select())
                        }, null, 8 /* PROPS */, ["label", "description", "selected", "onClick"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 12 /* STYLE, PROPS */, _hoisted_3)
            ]));
        };
    }
});
